export default __webpack_public_path__ + "static/media/user.d865d1ca.svg";